/* 🤖 this file was generated by svg-to-ts */
export const matIconBorderColor: {
  name: 'border-color';
  data: string;
} = {
  name: 'border-color',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m16.81 8.94-3.75-3.75L4 14.25V18h3.75l9.06-9.06zM6 16v-.92l7.06-7.06.92.92L6.92 16H6zm13.71-9.96a.996.996 0 0 0 0-1.41l-2.34-2.34a1.001 1.001 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83zM2 20h20v4H2z"/></svg>`
};
